import { render, staticRenderFns } from "./Resolution.vue?vue&type=template&id=e014dcbc&scoped=true&"
import script from "./Resolution.vue?vue&type=script&lang=js&"
export * from "./Resolution.vue?vue&type=script&lang=js&"
import style0 from "./Resolution.vue?vue&type=style&index=0&id=e014dcbc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e014dcbc",
  null
  
)

export default component.exports